// import styles from './InformationFormsStyle.module.scss'
import FormButtons from "./FormButtons"
import React, { useState } from 'react'
import { useEffect } from 'react';
import { baseUrl } from "../../common/constants";
import { toast } from "react-toastify";
import { mainContext } from "../../context/context";
import axios from "axios";
import _axios from "../../utils/api/_axios";
import { Content } from "antd/es/layout/layout";
import { useLocation, useParams } from "react-router-dom";
import { pageWrapper } from "../../utils/helpers";
import { Button, Col, Form, Input, Row } from "antd";
import { DeleteFilled, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { ProceduresSchema, validateField, validateProcedureField } from './Validations/FormsValidations';


const ProceduresForm = ({ isForm = true, patientId = "", claim = {}, fetchClaims, setSelectedClaim}) => {
    const {id} = useParams()
    const route = `/new-entry/details/${id}`
    const location = useLocation()
    const { currentTab, activeTab,formDataValues,getFormData , errors, setErrors} = React.useContext(mainContext);
    const [formValues, setFormValues] = useState([{ procedure: "", bodyParts: "", bodySide: "", diagnosisRuleOut1: "", diagnosisRuleOut2: "" }])
    const [message, setMessage] = useState("");
    const [isEditing, setIsEditing] = React.useState(true);
    const [isDisable,setIsDisable] = useState(false)

    const handleChange = (i, e) => {
        const { name, value } = e.target;

        let newFormValues = [...formValues];
        newFormValues[i][name] = value;
        setFormValues(newFormValues);

        let updatedProceduresInfo = formDataValues?.proceduresInfo || [];
        if (updatedProceduresInfo[i]) {
            updatedProceduresInfo[i] = {
                ...updatedProceduresInfo[i],
                [name]: value
            };
        } else {
            updatedProceduresInfo.push(newFormValues[i]);
        }

        const newErrors = { ...errors };
        const errorMessage = validateProcedureField(i, name, value, ProceduresSchema, newFormValues);
        if (errorMessage) {
            newErrors[`${i}.${name}`] = errorMessage;
        } else {
            delete newErrors[`${i}.${name}`];
        }
        setErrors(newErrors);
        getFormData({
            ...formDataValues,
            proceduresInfo: updatedProceduresInfo
        });
    };
    const addProcedure = () => {
        const newProcedure = { procedure: '', bodyParts: '', bodySide: '', diagnosisRuleOut1: '', diagnosisRuleOut2: '' };
        setFormValues([...formValues, newProcedure]);
        getFormData({
          ...formDataValues,
          proceduresInfo: [...(formDataValues.proceduresInfo || []), newProcedure],
        });
      };

    let deleteProcedure = (i) => {
        let newFormValues = [...formValues];
        newFormValues.splice(i, 1);
        setFormValues(newFormValues)
    }

    const map = (formValues) => {
        let value = [];
        formValues.forEach(p => {
            value = [...value, {
                procedure: p.procedure,
                bodyParts: p.bodyParts,
                bodySide: p.bodySide,
                diagnosisRuleOut1: p.diagnosisRuleOut1,
                diagnosisRuleOut2: p.diagnosisRuleOut2
            }];
        });
        return {
            "updateProperty": "procedures",
            "value": value
        }
    }

    let handleSubmit = async (event) => {
        event.preventDefault();
        setIsDisable(true);
        let claimId = sessionStorage.getItem("claimId");
        if(!patientId) {
            patientId = sessionStorage.getItem("patientId");
        }
      
        const { error } = ProceduresSchema.validate(formValues, { abortEarly: false });
      
        if (error) {
          const errorMessages = error.details.reduce((acc, detail) => {
            const path = detail.path.join('.');
            acc[path] = detail.message;
            return acc;
          }, {});
          setErrors(errorMessages);
          setIsDisable(false);
        } else {
          setErrors({});
          if (patientId && claim?._id) {
            claimId = claim?._id;
          }
          if (patientId && claimId) {
            try {
              let res = await _axios.put(`${baseUrl}/patients/${patientId}/claims/${claimId}`, map(formValues), {
                headers: {
                  'Content-Type': 'application/json'
                },
                cache: "no-cache"
              });
      
              let resJson = res.data;
              if (res.status === 200) {
                toast("Successfully saved patient.", {
                  type: "success",
                  autoClose: 3000,
                });
                setIsDisable(false);
                currentTab(4);
                if (!isForm) {
                  setIsEditing(false);
                }
                if(window.location.pathname === `/patient-info/${id}`){
                  // const response = fetchClaims(patientId);
                  // setSelectedClaim(response?.data?.payload?.find(claim => claim._id === claimId))
                  window.location.reload();
                }
              } else {
                toast("Unable to submit. Some error occured", {
                  type: "error",
                  autoClose: 3000,
                });
              }
            } catch (err) {
              console.log(err);
            }
          }
        }
      }
      

    const setValues = (payload) => {
         const values = payload.map(p => { return {
                procedure: p.procedure,
                bodyParts: p.bodyParts,
                bodySide: p.bodySide,
                diagnosisRuleOut1: p.diagnosisRuleOut1,
                diagnosisRuleOut2: p.diagnosisRuleOut2
            }
        });
        setFormValues(values)
    }

    let fetchInitial = async (patientId, claim) => {
        if(claim.status === 'Unassigned'){
          return;
        }
        let claimId = sessionStorage.getItem("claimId");
        if(!patientId) {
            patientId = sessionStorage.getItem("patientId");
        }
        if (patientId && claim?._id) {
            claimId = claim?._id;
            return claim.procedures;
        }
        // TODO pankaj, check this method will never be called, we can remove this later
        if (patientId && claimId) {
            try {
                let res = await _axios.get(`${baseUrl}/patients/${patientId}/claims/${claimId}?title=procedures`, {
                    params: {
                        title: 'procedures'
                    },
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                let resJson = res.data;
                if (res.status === 200) {
                    setMessage("User created successfully");
                } else {
                    setMessage("Some error occured");
                }
                return resJson.payload;
            } catch (err) {
                console.log(err);
            }
        }
    }

    const handleClose = () => {
        if (!isForm) {
            setIsEditing(false);
        }
    }

    useEffect(() => {
        setIsEditing(isForm);
        fetchInitial(patientId, claim).then((payload) => {
            if (payload?.length) {
                setValues(payload);
            }
        });
    }, [])

    let fetchProcedureInfo = async (patientId = "") => {
        if (patientId || id) {
            try {
                const URL = window.location.pathname === route ? `${baseUrl}/openAccess/${id}` : `${baseUrl}/patients/${patientId}`
                const response = await _axios.get(URL);
                let renderResponse = location.pathname === route ? response.data?.payload?.proceduresInfo : response.data?.payload
                if (response.status === 200) {
                    // TODO pankaj, remove all irrelevant set messages and use toast message
                    setMessage("User created successfully");
                  } else {
                    setMessage("Some error occured");
                  }
                  return renderResponse;
                } catch (err) {
                  console.log(err);
                }
                }
              };

      const mapAPIDataToFormData = (payload) => {
        const mapData = window.location.pathname === route ? Object.values(payload) : payload;
        const formData = mapData.map(item => ({
            procedure: item?.procedure || "",
            bodyParts: item?.bodyParts || "",
            bodySide: item?.bodySide || "",
            diagnosisRuleOut1: item?.diagnosisRuleOut1 || "",
            diagnosisRuleOut2: item?.diagnosisRuleOut2 || ""
        }));
        return formData;
    };

    const setPatientValues = (patient) => {
        const formPayload = { ...patient, patientId: patient?._id }
        let arrayData = []
        arrayData.push(formPayload)
        const renderValue =  window.location.pathname === route ? formPayload : arrayData
        setFormValues(mapAPIDataToFormData(renderValue));
      };

    useEffect(() => {
        if (window.location.pathname === route) {
            fetchProcedureInfo().then((payload) => {
                if (payload) setPatientValues(payload);
            });
        }
      }, []);
    const formRender=()=>{
        return (
<form className={`${isEditing ? "bg-gray-100 shadow-md rounded-lg p-6 mb-6" : "bg-white border border-gray-300 rounded-lg p-6 mb-6"}`} onSubmit={handleSubmit}>
<div className="flex justify-between items-center bg-gray-600 text-white p-4 rounded-t-lg">
              <h4 className="text-lg font-semibold">Procedures</h4>
              {!isEditing && (
                <div className="flex space-x-2">
                  <div className="cursor-pointer hover:text-gray-200" onClick={() => setIsEditing(true)}>
                    <EditOutlined className="text-xl" />
                  </div>
                </div>
              )}
            </div>
          
            {formValues.map((element, index) => (
              <div key={index} className="border border-gray-300 bg-white rounded-lg p-4 mt-4 shadow-sm">
                <div className="flex justify-between items-center">
                  <span className="font-semibold">Procedure {index + 1}</span>
                  {isEditing && (
                    <Button className="bg-red-500 text-white rounded p-1 hover:bg-red-600" onClick={() => deleteProcedure(index)}>
                      <DeleteFilled className="text-lg" />
                    </Button>
                  )}
                </div>
                <hr className="my-2" />
          
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                  {isEditing ? (
                   <>
                   <Form.Item label="Procedure:" className="w-full">
                     <Input
                       name="procedure"
                       className="w-full border border-gray-300 rounded p-2"
                       placeholder="Procedure"
                       value={element.procedure || ""}
                       onChange={(e) => handleChange(index, e)}
                     />
                   </Form.Item>
                   <Form.Item label="Body Part:" className="w-full">
                     <Input
                       name="bodyParts"
                       className="w-full border border-gray-300 rounded p-2"
                       placeholder="Body Part"
                       value={element.bodyParts || ""}
                       onChange={(e) => handleChange(index, e)}
                     />
                   </Form.Item>
                   <Form.Item label="Body Side:" className="w-full">
                     <Input
                       name="bodySide"
                       className="w-full border border-gray-300 rounded p-2"
                       placeholder="Body Side"
                       value={element.bodySide || ""}
                       onChange={(e) => handleChange(index, e)}
                     />
                   </Form.Item>
                 </>
                 
                  ) : (
                    <>
                      <div><b>Procedure:</b> {element.procedure || ""}</div>
                      <div><b>Body Part:</b> {element.bodyParts || ""}</div>
                      <div><b>Body Side:</b> {element.bodySide || ""}</div>
                    </>
                  )}
                </div>
          
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
                  {isEditing ? (
                    <>
                      <Form.Item label="Diagnosis / ICD-10:" className="w-full">
                        <Input   name="diagnosisRuleOut1" className="w-full border border-gray-300 rounded p-2" placeholder="Diagnosis / ICD-10" value={element.diagnosisRuleOut1 || ""} onChange={e => handleChange(index, e)} />
                      </Form.Item>
                      <Form.Item label="Diagnosis / ICD-10:" className="w-full">
                        <Input      name="diagnosisRuleOut2"   className="w-full border border-gray-300 rounded p-2" placeholder="Diagnosis / ICD-10" value={element.diagnosisRuleOut2 || ""} onChange={e => handleChange(index, e)} />
                      </Form.Item>
                    </>
                  ) : (
                    <>
                      <div><b>Diagnosis / Rule Out 1:</b> {element.diagnosisRuleOut1 || ""}</div>
                      <div><b>Diagnosis / Rule Out 2:</b> {element.diagnosisRuleOut2 || ""}</div>
                    </>
                  )}
                </div>
              </div>
            ))}
          
            {isEditing && (
              <>
                <div className="flex justify-end mt-4">
                  <FormButtons handleClose={handleClose} isDisable={isDisable} />
                </div>
                <div className="flex justify-end mt-4">
                  <Button className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700" onClick={addProcedure}>
                    <PlusOutlined className="mr-2" /> Add New Procedure
                  </Button>
                </div>
              </>
            )}
          </form>
        )
    }

    return (
        <Content className="">
        {formRender()}
    </Content>
    
    )
}

export default ProceduresForm